import {
  CART_POPULAR_ITEMS_PRODUCTS_LIST,
  FETCH_PRINT_STORE_SHOPPING_CART,
  GET_ESTIMATED_DELIVERY_DATE
} from '@dtx-company/flow-codegen/src/code/queries'
import {
  CartPopularItemsProductsListQuery,
  CartPopularItemsProductsListQueryVariables,
  EstimatedDeliveryDateQuery,
  EstimatedDeliveryDateQueryVariables,
  ShoppingCartQuery,
  ShoppingCartQueryVariables
} from '@dtx-company/flow-codegen/src/code/generated.types'
import { flowcodeApi } from './init'

export const printStoreQueries = flowcodeApi.injectEndpoints({
  endpoints: builder => ({
    shoppingCart: builder.query<ShoppingCartQuery, ShoppingCartQueryVariables>({
      query: () => ({
        document: FETCH_PRINT_STORE_SHOPPING_CART,
        authOnly: true
      }),
      providesTags: ['ShoppingCart']
    }),
    getEstimatedDeliveryDate: builder.query<
      EstimatedDeliveryDateQuery,
      EstimatedDeliveryDateQueryVariables
    >({
      query: ({ handlingOptionId, shippingOptionId }) => ({
        document: GET_ESTIMATED_DELIVERY_DATE,
        variables: { handlingOptionId, shippingOptionId },
        authOnly: true
      }),
      providesTags: (_result, _error, { handlingOptionId, shippingOptionId }) => [
        { type: 'EstimatedDeliveryDate', handlingOptionId, shippingOptionId }
      ]
    }),
    otherPopularItems: builder.query<
      CartPopularItemsProductsListQuery,
      CartPopularItemsProductsListQueryVariables
    >({
      query: ({ limit, sortBy }) => ({
        document: CART_POPULAR_ITEMS_PRODUCTS_LIST,
        variables: {
          limit,
          sortBy
        },
        authOnly: true
      }),
      providesTags: ['OtherPopularItems']
    })
  })
})

export const { useShoppingCartQuery, useGetEstimatedDeliveryDateQuery, useOtherPopularItemsQuery } =
  printStoreQueries
